<template>
  <div class="page-clue">
    <crm-panel :title="'医生列表'">
      <!-- 操作按钮 -->
      <div class="page-buttons">
        <!-- <crm-button
          v-if="webGovAuth.add.auth"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="toAdd()">
        </crm-button>
        <crm-button
          v-if="webGovAuth.export.auth"
          :buttonType="'plain'"
          :text="'导出'"
          @click="handleExport()">
        </crm-button> -->
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="form" :inline="true" :model="form">
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="请输入省、市"
              v-model="form.regionName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="请输入医生姓名"
              v-model="form.doctorName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="请输入医院ID"
              v-model="form.hospitalId"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="请输入医院名称"
              v-model="form.hospitalName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="请输入科室名称"
              v-model="form.hospDeptName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="请输入科室ID"
              v-model="form.hospDeptId"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="doctorListData && doctorListData.results"
        border
        v-loading="loading"
        fit
        height="100%"
        style="width: 100%"
      >
        <el-table-column prop="pkid" align="center" label="医生ID">
        </el-table-column>
        <el-table-column prop="doctorName" align="center" label="医生姓名">
        </el-table-column>
        <el-table-column prop="hospitalId" align="center" label="医院ID">
        </el-table-column>
        <el-table-column prop="hospitalName" align="center" label="医院名称">
        </el-table-column>
        <el-table-column prop="hospDeptId" align="center" label="科室ID">
        </el-table-column>
        <el-table-column prop="hospDeptName" align="center" label="科室名称">
        </el-table-column>
        <el-table-column
          prop="doctorAdminTitleName"
          align="center"
          label="职称"
        >
        </el-table-column>
        <el-table-column align="center" width="200px" label="地区">
          <template slot-scope="{ row }">
            {{
              [row.firstHospProvName, row.firstHospCityName]
                .filter(Boolean)
                .join('/')
            }}
          </template>
        </el-table-column>
        <el-table-column prop="regDate" align="center" label="注册日期">
        </el-table-column>
        <!-- <el-table-column
          fixed="right"
          width="120"
          align="center"
          label="操作"> -->
        <!-- <template slot-scope="{row}"> -->
        <!-- <el-button
              v-if="webGovAuth.update.auth"
              @click="toEdit(row)"
              type="text"
              size="small">
              编辑
            </el-button> -->
        <!-- <el-button
              v-if="webGovAuth.delete.auth"
              @click="delCus(row)"
              type="text"
              size="small">
              删除
            </el-button> -->
        <!-- </template> -->
        <!-- </el-table-column> -->
      </el-table>
      <!-- 医生列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagenation.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="(doctorListData && doctorListData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import config from '~config';
import { filterStr } from '@/scripts/reg';
import CrmPanel from '@/components/base/crmPanel';

export default {
  components: {
    CrmPanel,
  },
  filters: {},
  data() {
    return {
      // 是否医生运营，展示定制化医生运营列表
      loading: true,
      // 客户名称表单，提交时会根据表单下方的单选按钮传给后台不同的key，所以单独拎出来
      searchName: '',
      // 搜索表单
      time: [],
      form: {
        regionName: null,
        hospitalId: null,
        hospitalName: null,
        hospDeptId: null,
        hospDeptName: null,
        doctorName: null,
      },
      nameType: 1,
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapGetters({
      doctorListData: 'customer/doctorListData',
    }),
  },
  watch: {},
  created() {
    // 初始客户列表
    this.handleGetDoctorList(this.pagenation);
  },
  methods: {
    ...mapActions({
      getCrmDoctorList: 'customer/getCrmDoctorList',
    }),
    handleGetDoctorList(params) {
      this.loading = true;
      this.getCrmDoctorList(params).finally(() => {
        this.loading = false;
      });
    },
    // 根据条件刷新客户列表
    refreshDoctorList() {
      const startTimeStr = this.time ? this.time[0] : '';
      const endTimeStr = this.time ? this.time[1] : '';
      const time = {
        startTimeStr,
        endTimeStr,
      };
      this.form.hospitalName = filterStr(this.form.hospitalName);
      this.form.hospDeptName = filterStr(this.form.hospDeptName);
      this.form.doctorName = filterStr(this.form.doctorName);
      this.form.regionName = filterStr(this.form.regionName);
      return this.handleGetDoctorList(
        Object.assign(this.pagenation, this.form, time),
      );
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.refreshDoctorList();
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetDoctorList(this.pagenation);
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetDoctorList(this.pagenation);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/const.less';
.page-clue {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
